import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-legal">
          <a href="/impressum" rel="nofollow">Impressum</a>
          <a href="/datenschutz" rel="nofollow">Datenschutz</a>
        </div>
        <div className="footer-copyright">
          © {currentYear} Julian Streibel. Alle Rechte vorbehalten.
        </div>
      </div>
    </footer>
  );
}

export default Footer; 